import BackButtonPage from '../../../../../components/BackButtonPage';
import "../../../../../styles/AdottTortenelmiPillanat.css"


function AdottTortenelmiPillanat() {
  return (
    <div className='page-content-container adott-tortenelmi-pillanat-container'>
    <p>
        <div>
            NEMES MIHÁLY, NAGY GÉZA Magyar viseletek története BUDAPEST 
        </div>
        <div>
            FRANKLIN-TÁRSULAT MAGYAR IROD. INTÉZET ÉS KÖNYVNYOMDA 1900 
        </div>
    </p>
    <p>
        A honfoglalóktól a huszárokig B. Szabó János 2010
    </p>
    <p>
        Magyar Hadtörténelmi emlékek az Ezeréves Országos kiállításon Dr Szendrei János 1896
    </p>
    <p>
        A Dunai hajóhadak története Dr Szentkláray Jenő 1885
    </p>
    <p>
        Csonkaréti Károly Hadihajók a Dunán 1980
    </p>
    <p>
        <div>
            B. Szabó János: A Magyar Királyság hadszervezete és hadserege (1490–1529). 
        </div>
        <div>
            In: Új korszak határán. Az eu rópai államok hadügye és hadseregei a mohácsi csata 
        </div>
        <div>
            korában. Szerk. Fodor Pál – B. Szabó János. Budapest, 2019. 67–93. o.
        </div>
    </p>
    <p>
        <div>
            B. SZABÓ JÁNOS A MOHÁCSI CSATA ÉS A „HADÜGYI FORRADALOM" II. rész A 
        </div>
        <div>
            magyar hadsereg a mohácsi csatában hadtortenelmi közlemények 2005 03 573-632
        </div>
    </p>
    <p>
        B. Szabó János Mohácsi vész - Árkádia.hu szakmódszertani portál
    </p>
    <p>
        Kovács S. Tibor: A Kopaszi-zátonyi fegyverek. In: Folia Archaeologia 43. Szerk. Fodor 
    </p>
        István. Budapest, 1994. 251–278. o.
    <p>
        <div>
            Kozák Károly: Magyar nyélbeütős szakállas puskák. In: Folia Archaeologia 9. Szerk. 
        </div>
        <div>
            Fülep Ferenc. Budapest, 1957. 167–177. o. 
        </div>
        <div>
            Kozák Károly: A magyarországi szakállaspuskák fejlő déstörténetéről. Archaeologiai 
        </div>
        <div>
            Értesítő, 101. (1974) 2. füz. 290–303. o.
        </div>
    </p>
    <p>
        Négyesi Lajos: A mohácsi csata. Hadtörténelmi Közlemények, 107. (1994) 1. sz. 62–79. o.
    </p>
    <p>
        <div>
            NÉMETH BALÁZS A MOHÁCSI CSATA KISKALIBERŰ KÉZI LŐFEGYVEREINEK 
        </div>
        <div>
            KÉRDÉSÉHEZ I. Hadtörténelmi közlemények 2021 01 167-228
        </div>
    </p>
    <p>
        <div>
            Dr Takáts Sándor A Dunai hajózás a XVI. és XVII. században   
        </div>
        <div>
            gazd_tort_szeml_1900_097-122 
        </div>
    </p>
    <p>
        <div>
            Szokola László Magyarországi városok zsoldos állításának politikai és gazdasági háttere. 
        </div>
        <div>
            - In: Székely G. (Szerk.): Magister Historiae II. Budapest, Elte BTK 
        </div>
        <div>
            Történelemtudományok Doktori Iskola, 2016.
        </div>
    </p>
    <p>
        Veszprémy László: A számszeríj használata Magyarországon Lovagvilág Magyarországon. 
        Budapest, Argumentum Kiadó, 2008.
    </p>
    <p>
        <div>
            Stettner, Heinrich Schiffe, in Holz geschnitten: maritime Buchillustrationen zu 
        </div>
        <div>
            Maximilians "Weißkunig", seinem "Teuerdank" und zu Petrarcas "Trostspiegel" aus der 
        </div>
        <div>
            ersten Hälfte des 16. Jahrhunderts
        </div>
    </p>
    <p>
        <div>
            Suart Gorman The Technological Development of the Bow and the Crossbow in the 
        </div>
        <div>
            Later Middle Ages                   Trinity College Dublin 2016
        </div>
    </p>
    <p>
        <div>
            Ralph Payne-Galwey The Book of the Crossbow Dover Publications, INC. New York 
        </div>
        <div>
            1995
        </div>
    </p>
    <p>
        Marjai Imre, Pataky Dénes A hajó története  Corvina 1973
    </p>
    <p>
        <div>
            Töll László: A számszeríjról – A Déri Múzeum számszeríjai  A Debreceni Déri Múzeum 
        </div>
        <div>
            Évkönyve 1992-1993 (Debrecen, 1994)
        </div>
    </p>
    <p>
        <div>
            Töll László A HARCI VÉRTEZETEK TÖRTÉNETE A nyugat-európai hadviselésben 
        </div>
        <div>
            alkalmazott testvédelmi rendszerek fejlődéstörténete a 10. századtól a 16. század első 
        </div>
        <div>
            harmadáig  Debreceni Egyetem BTK 2009
        </div>
    </p>
    <p>
        <div>
            Töll, László · A számszeríj - az ördögi fegyver 1. – 2. VÁRAK KASTÉLYOK TEMPLOMOK:
        </div>
        <div>
            TÖRTÉNELMI ÉS ÖRÖKSÉGTURISZTIKAI FOLYÓIRAT (2005).
        </div>
    </p>

 

  



        <BackButtonPage to="/ter-segedlet" />
    </div>
  );
}

export default AdottTortenelmiPillanat;
